export type Mode = 'troubadour' | 'maestro';
export type Status = 'empty' | 'recording' | 'ready' | 'busy';

export interface Loop {
  id: string;
  name: string;
  start: number;
  end: number;
  mixed: boolean;
}

/** Une piste = une couche audio autonome (une prise ou une boucle promue),
 *  jouée en superposition avec les autres. */
export interface Track {
  id: string;
  name: string;
  buffer: AudioBuffer;
  volume: number; // 0..1
  muted: boolean;
}

export interface Selection {
  start: number;
  end: number;
}

export interface KeyInfo {
  root: number;
  minor: boolean;
  confidence: number;
  name: string;
  token: string;
}

export interface Analysis {
  duration: number;
  sampleRate: number;
  bpm: number | null;
  key: KeyInfo | null;
  engine: string | null;
  onsets: number[];
  strengths: number[];
}

export interface QuantizeMeta {
  mode: string;
  engine: string;
  bpm: number;
  division: number;
  grid_offset: number;
  moves: number;
  stretched_segments: number;
  rubberband: boolean;
}

export interface DenoiseMeta {
  [key: string]: unknown;
}

export interface Capabilities {
  rubberband: boolean;
  librosa: boolean;
  noisereduce: boolean;
}

export interface HealthInfo {
  status: string;
  service: string;
  version: string;
  capabilities: Capabilities;
}

/** Divisions de grille proposées, exprimées comme fraction de temps (noire). */
export const DIVISIONS: { value: number; label: string; plain: string }[] = [
  { value: 1, label: '1/4', plain: 'un temps' },
  { value: 0.5, label: '1/8', plain: 'demi-temps' },
  { value: 1 / 3, label: '1/8 triolet', plain: 'triolets' },
  { value: 0.25, label: '1/16', plain: 'quart de temps' },
  { value: 0.125, label: '1/32', plain: 'très fin' },
];
